/**
 * Enum representing user preference for displaying accidentals.
 * @enum {string} AccidentalPreference
 * @property {string} Sharp - Display notes with sharp accidentals (e.g., C#, F#)
 * @property {string} Flat - Display notes with flat accidentals (e.g., Db, Gb)
 */
export enum AccidentalPreference {
  Sharp = 'sharp',
  Flat = 'flat',
}
